const scrollIntoViewWithOffset = (
  element: HTMLElement,
  offset: number,
  behavior: ScrollBehavior = 'smooth'
) => {
  window.scrollTo({
    behavior,
    top:
      (element.getBoundingClientRect().top ?? 0) -
      document.body.getBoundingClientRect().top -
      offset,
  });
};

export default scrollIntoViewWithOffset;
